<template>
  <div class="login-html-page">
    <div class="campus-bg" aria-hidden="true">
      <svg
        class="campus-element campus-buildings"
        viewBox="0 0 1000 500"
        fill="none"
        stroke="#0284c7"
        stroke-width="2.5"
      >
        <rect x="350" y="200" width="300" height="280" rx="6" />
        <rect x="400" y="250" width="80" height="230" rx="4" />
        <rect x="520" y="250" width="80" height="230" rx="4" />
        <rect x="100" y="150" width="180" height="330" rx="6" />
        <rect x="130" y="180" width="40" height="40" rx="3" />
        <rect x="130" y="240" width="40" height="40" rx="3" />
        <rect x="190" y="180" width="40" height="40" rx="3" />
        <rect x="720" y="150" width="180" height="330" rx="6" />
        <rect x="750" y="180" width="40" height="40" rx="3" />
        <rect x="810" y="180" width="40" height="40" rx="3" />
      </svg>
      <svg
        class="campus-element campus-orb"
        viewBox="0 0 500 500"
        fill="none"
        stroke="#0284c7"
        stroke-width="1.5"
      >
        <circle cx="250" cy="250" r="200" />
        <circle cx="250" cy="250" r="160" />
        <circle cx="250" cy="250" r="120" />
      </svg>
      <svg
        class="campus-element campus-tree"
        viewBox="0 0 100 150"
        stroke="#0284c7"
        stroke-width="2"
        fill="none"
      >
        <rect x="45" y="80" width="10" height="70" />
        <circle cx="50" cy="60" r="30" />
        <circle cx="30" cy="70" r="20" />
        <circle cx="70" cy="70" r="20" />
      </svg>
      <svg
        class="campus-element campus-flag"
        viewBox="0 0 50 130"
        stroke="#0284c7"
        stroke-width="2"
        fill="none"
      >
        <rect x="20" y="20" width="3" height="110" />
        <rect x="23" y="25" width="25" height="15" rx="2" />
      </svg>
      <svg
        class="campus-element campus-track"
        viewBox="0 0 200 100"
        stroke="#0284c7"
        stroke-width="2"
        fill="none"
      >
        <path d="M20 80 Q100 20 180 80" stroke-dasharray="5 5" />
        <path d="M20 90 Q100 30 180 90" stroke-dasharray="5 5" />
      </svg>
      <svg
        class="campus-element campus-light"
        viewBox="0 0 20 100"
        stroke="#0284c7"
        stroke-width="2"
        fill="none"
      >
        <rect x="9" y="30" width="2" height="70" />
        <circle cx="10" cy="25" r="8" />
      </svg>
      <svg
        class="campus-element campus-book"
        viewBox="0 0 100 60"
        stroke="#0284c7"
        stroke-width="2"
        fill="none"
      >
        <path d="M10 10 Q50 0 90 10 L90 50 Q50 60 10 50 Z" />
        <path d="M50 10 V50" />
      </svg>
      <svg
        class="campus-element campus-hat"
        viewBox="0 0 100 100"
        stroke="#0284c7"
        stroke-width="2"
        fill="none"
      >
        <rect x="20" y="35" width="60" height="40" rx="2" />
        <polygon points="50 15,85 35,50 55,15 35" />
        <circle cx="50" cy="20" r="8" />
      </svg>
      <svg
        class="campus-element campus-bell"
        viewBox="0 0 100 120"
        stroke="#0284c7"
        stroke-width="2"
        fill="none"
      >
        <rect x="30" y="20" width="40" height="80" rx="2" />
        <circle cx="50" cy="40" r="15" />
        <rect x="45" y="65" width="10" height="30" />
      </svg>
      <svg
        class="campus-element campus-basketball"
        viewBox="0 0 200 150"
        stroke="#0284c7"
        stroke-width="2"
        fill="none"
      >
        <rect x="20" y="20" width="160" height="100" rx="4" />
        <circle cx="100" cy="70" r="20" />
        <rect x="80" y="50" width="40" height="40" />
      </svg>
      <svg
        class="campus-element campus-fountain"
        viewBox="0 0 100 100"
        stroke="#0284c7"
        stroke-width="2"
        fill="none"
      >
        <circle cx="50" cy="50" r="40" />
        <circle cx="50" cy="50" r="25" />
        <path d="M50 10 L50 30 M50 70 L50 90 M10 50 L30 50 M70 50 L90 50" />
      </svg>
      <svg
        class="campus-element campus-bus"
        viewBox="0 0 200 100"
        stroke="#0284c7"
        stroke-width="2"
        fill="none"
      >
        <rect x="20" y="30" width="150" height="50" rx="6" />
        <rect x="130" y="10" width="40" height="20" rx="2" />
        <circle cx="50" cy="80" r="15" />
        <circle cx="140" cy="80" r="15" />
      </svg>
      <svg
        class="campus-element campus-bird"
        viewBox="0 0 100 60"
        stroke="#0284c7"
        stroke-width="2"
        fill="none"
      >
        <path d="M10 30 Q30 10 50 30 Q70 10 90 30" />
        <path d="M50 30 L50 50" />
      </svg>
      <svg
        class="campus-element campus-table"
        viewBox="0 0 80 60"
        stroke="#0284c7"
        stroke-width="2"
        fill="none"
      >
        <rect x="10" y="20" width="60" height="10" rx="1" />
        <rect x="20" y="30" width="8" height="20" />
        <rect x="52" y="30" width="8" height="20" />
      </svg>
    </div>

    <div class="login-split-card">
      <!-- 左侧：参考图蓝渐变 + 玻璃卡片 -->
      <aside class="login-split-left">
        <div class="login-split-left-inner">
          <div class="left-brand">
            <h1 class="left-brand-title">智慧校园平台</h1>
            <p class="left-brand-sub">安全 · 高效 · 一站式服务</p>
          </div>
          <div class="glass-cards">
            <div
              class="glass-card"
              v-for="(item, index) in homeDesc"
              :key="index"
            >
              <i class="glass-icon" :class="item.icon"></i>
              <div class="glass-text">
                <div class="glass-title">{{ item.title }}</div>
                <div class="glass-sub">{{ item.sub }}</div>
              </div>
            </div>
          </div>
        </div>
      </aside>
      <div class="right-panel">
        <div class="login-card">
          <div class="toggle-btn-container">
            <el-button type="text" class="toggle-btn" @click="toggleLoginType">
              {{ isQrLogin ? "账号密码登录" : "二维码登录" }}
            </el-button>
          </div>

          <div class="form-wrapper">
            <div class="form-header">
              <h2>欢迎登录</h2>
              <p class="desc">{{ schoolName }} · 智慧校园平台</p>
            </div>

            <el-form
              v-show="!isQrLogin"
              ref="loginForm"
              :model="loginForm"
              :rules="loginRules"
              label-width="0"
              class="login-form"
            >
              <el-form-item prop="username">
                <el-input
                  v-model="loginForm.username"
                  placeholder="请输入教职工账号"
                  prefix-icon="el-icon-user"
                  size="large"
                  class="input-item"
                />
              </el-form-item>

              <el-form-item prop="password">
                <el-input
                  v-model="loginForm.password"
                  type="password"
                  placeholder="请输入登录密码"
                  prefix-icon="el-icon-lock"
                  show-password
                  size="large"
                  class="input-item"
                  @keyup.enter.native="handleLogin"
                />
              </el-form-item>

              <div class="option-row">
                <el-checkbox v-model="rememberMe" class="remember-checkbox"
                  >记住密码</el-checkbox
                >
                <a href="javascript:" class="forget">忘记密码？联系管理员</a>
              </div>

              <el-form-item>
                <el-button
                  type="primary"
                  size="large"
                  round
                  class="login-btn"
                  :loading="loading"
                  @click="handleLogin"
                >
                  登 录
                </el-button>
              </el-form-item>
            </el-form>

            <div v-show="isQrLogin" class="qr-login-container">
              <div class="qr-card">
                <div class="qr-header">
                  <span>扫码登录</span>
                  <el-button
                    type="text"
                    class="refresh-qr"
                    @click="refreshQrcode"
                  >
                    刷新二维码
                  </el-button>
                </div>
                <img :src="qrcodeUrl" alt="扫码登录" class="qrcode-img" />
                <p class="qr-tip">请使用校园APP扫码登录</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="footer-text">
      <span>© {{ year }} 成都比程科技有限公司 版权所有</span>
    </div> -->
    <div class="login-copyright">
      <copyright />
    </div>
  </div>
</template>

<script>
import defaultQrcode from "../assets/image/erweim.jpg";
import copyright from "../components/copyright.vue";

export default {
  name: "Login1",
  inject: ["api"],
  components: { copyright },
  data() {
    return {
      loading: false,
      rememberMe: true,
      isQrLogin: false,
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: true, message: "请输入教职工账号", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          { min: 3, message: "密码不少于3位", trigger: "blur" },
        ],
      },
      qrcodeUrl: defaultQrcode,
      schoolName: "成都比程科技",
      homeDesc: [
        {
          icon: "el-icon-s-data",
          title: "数据可视化分析",
          sub: "校园数据一目了然",
        },
        {
          icon: "el-icon-document",
          title: "智慧教务管理",
          sub: "一站式教学服务",
        },
        { icon: "el-icon-bell", title: "实时消息通知", sub: "多渠道精准触达" },
      ],
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
  mounted() {
    this.fillRememberPassword();
  },
  methods: {
    toggleLoginType() {
      this.isQrLogin = !this.isQrLogin;
    },
    refreshQrcode() {},
    fillRememberPassword() {
      var user = localStorage.getItem("loginUser");
      if (user) {
        try {
          var info = JSON.parse(user);
          this.loginForm.username = info.username;
          this.loginForm.password = info.password;
          this.rememberMe = true;
        } catch (e) {}
      }
    },
    saveRememberPassword(remember, data) {
      if (remember) {
        localStorage.setItem(
          "loginUser",
          JSON.stringify({
            username: data.username,
            password: data.password,
          })
        );
      } else {
        localStorage.removeItem("loginUser");
      }
    },
    handleLogin() {
      var self = this;
      var formData = {
        Account: self.loginForm.username,
        Password: self.loginForm.password,
      };
      self.$refs.loginForm.validate(function (valid) {
        if (!valid) return;
        self.loading = true;
        $.ajax({
          url: "/api/Auth/Login",
          type: "POST",
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          data: JSON.stringify(formData),
          cache: false,
          timeout: 15000,
          success: function (res) {
            self.loading = false;
            if (res.IsSuccess) {
              self.$message.success("登录成功");
              sessionStorage.removeItem("courseTableParams");
              sessionStorage.removeItem("app_nav_tabs_history");
              self.saveRememberPassword(self.rememberMe, self.loginForm);
              // 登录成功后，将过期时间存储到localStorage中
              const expireTimestamp =
                Date.now() + Number(res.Data.ExpiresIn) * 60 * 1000;
              localStorage.setItem("tokenExpireTime", String(expireTimestamp));
              localStorage.setItem("token", res.Data.Token);
              self.$router.push("/basic");
            } else {
              self.$message.error(res.Message || "登录失败");
            }
          },
          error: function (err) {
            self.loading = false;
            self.$message.error((err && err.Message) || "网络异常，请重试");
          },
        });
      });
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.login-html-page {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: auto;
  background: linear-gradient(160deg, #e0f2fe, #f0f9ff, #ffffff);
}

.campus-bg {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 1;
}

.campus-element {
  position: absolute;
  z-index: 1;
  opacity: 0.18;
  animation: login1-float 12s infinite ease-in-out;
}
.campus-buildings {
  width: 1100px;
  height: 550px;
  bottom: -120px;
  left: 50%;
  transform: translateX(-50%);
  animation: login1-float-buildings 12s infinite ease-in-out;
}
.campus-orb {
  width: 750px;
  height: 750px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: login1-spin 40s linear infinite;
}
.campus-tree {
  width: 220px;
  height: 320px;
  bottom: -60px;
  left: 12%;
}
.campus-flag {
  width: 100px;
  height: 260px;
  bottom: 100px;
  left: 24%;
}
.campus-track {
  width: 400px;
  height: 200px;
  bottom: -40px;
  right: 10%;
}
.campus-light {
  width: 60px;
  height: 240px;
  bottom: 20px;
  right: 22%;
}
.campus-book {
  width: 180px;
  height: 120px;
  top: 12%;
  left: 18%;
}
.campus-hat {
  width: 140px;
  height: 140px;
  top: 18%;
  right: 16%;
}
.campus-bell {
  width: 160px;
  height: 200px;
  top: 8%;
  left: 5%;
}
.campus-basketball {
  width: 260px;
  height: 200px;
  bottom: 10%;
  right: 5%;
}
.campus-fountain {
  width: 180px;
  height: 180px;
  bottom: 5%;
  left: 35%;
}
.campus-bus {
  width: 240px;
  height: 120px;
  top: 25%;
  right: 2%;
}
.campus-bird {
  width: 200px;
  height: 120px;
  top: 5%;
  right: 30%;
}
.campus-table {
  width: 120px;
  height: 100px;
  bottom: 15%;
  left: 5%;
}

@keyframes login1-float {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes login1-float-buildings {
  0% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(-12px);
  }
  100% {
    transform: translateX(-50%) translateY(0);
  }
}
@keyframes login1-spin {
  0% {
    transform: translate(-50%, -50%) rotate(0);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.login-split-card {
  display: flex;
  width: 100%;
  max-width: 920px;
  background: #fff;
  border-radius: 28px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.12);
  z-index: 2;
}

.login-split-left {
  flex: 0 0 50%;
  min-width: 280px;
  background: linear-gradient(180deg, #4facfe 0%, #2563eb 45%, #1d4ed8 100%);
  position: relative;
  padding: 48px 36px;
  display: flex;
  align-items: stretch;
}

.login-split-left-inner {
  width: 100%;
}

.left-brand-title {
  font-size: 26px;
  line-height: 36px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
}

.left-brand-sub {
  margin-top: 12px;
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.88);
}

.glass-cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
}

.glass-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transition: transform 0.28s ease, box-shadow 0.28s ease, background 0.28s ease,
    border-color 0.28s ease;
}

.glass-card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.2),
    0 8px 20px rgba(37, 99, 235, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.2) inset;
}

.glass-icon {
  font-size: 28px;
  color: rgba(255, 255, 255, 0.95);
  flex-shrink: 0;
}

.glass-title {
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: #fff;
}

.glass-sub {
  margin-top: 8px;
  font-size: 12px;
  line-height: 16px;
  color: rgba(255, 255, 255, 0.78);
}

.right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 36px;
  position: relative;
  background: #fff;
}

.login-card {
  width: 100%;
  max-width: 480px;
  background: #ffffff;
  border-radius: 24px;
  padding: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
  position: relative;
}

.toggle-btn-container {
  position: absolute;
  top: 12px;
  right: 24px;
}

.toggle-btn {
  font-size: 14px;
  line-height: 20px;
  padding: 0;
}

.toggle-btn:hover {
  background: transparent;
}

.form-header h2 {
  font-size: 30px;
  line-height: 40px;
  color: #1f2937;
  margin-bottom: 12px;
  font-weight: 700;
}

.desc {
  color: #6b7280;
  font-size: 16px;
  line-height: 22px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 40px;
}
.login-form .el-form-item {
  margin-bottom: 0 !important;
}

.input-item {
  --el-input-border-radius: 20px;
  --el-input-border-color: #e5e7eb;
  --el-input-bg-color: #f9fafb;
}

.option-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 20px;
}

.remember-checkbox {
  color: #6b7280;
}

.forget {
  color: #409eff;
  text-decoration: none;
}

.login-btn {
  width: 100%;
  font-size: 18px;
  line-height: 20px;
  font-weight: 600;
  border: none;
  color: #fff;
  margin-top: 12px;
  background: #4889f2;
}

.login-btn:hover {
  opacity: 0.92;
}

.login-copyright {
  position: fixed;
  bottom: 0;
}

.login-copyright .banquan {
  background: transparent;
}

.qr-login-container {
  padding: 24px 0 0;
  text-align: center;
}

.qr-card {
  display: inline-block;
  background: #fff;
  border-radius: 16px;
}

.qr-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 18px;
  line-height: 24px;
  color: #1f2937;
}

.refresh-qr {
  font-size: 14px;
  line-height: 20px;
  color: #409eff;
  padding: 0;
}

.qrcode-img {
  width: 180px;
  height: 180px;
  border-radius: 8px;
}

.qr-tip {
  margin-top: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #6b7280;
}

@media (max-width: 768px) {
  .login-split-card {
    flex-direction: column;
    max-width: 440px;
    min-height: 0;
  }

  .login-split-left {
    flex: none;
    min-width: 0;
    padding: 16px;
  }

  .glass-cards {
    display: none;
  }
  .right-panel {
    padding: 16px;
  }
  .login-card {
    box-shadow: none;
    padding: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/login/login.vue